// import Layout from "../Layout";
// import FrontPageLayout from "../FrontPageLayout";
// import ViewArticleLayout from "../ViewArticleLayout";
const Layout = () => import(/* webpackChunkName: "group-front" */ "../Layout.vue");
const FrontPageLayout = () => import(/* webpackChunkName: "group-front" */ "../FrontPageLayout.vue");
const ViewArticleLayout = () => import(/* webpackChunkName: "group-front" */ "../ViewArticleLayout.vue");

export default [
  {
    path: "/",
    name: "frontpagelayout",
    redirect: { name: "frontpage" },
    component: Layout,
    children: [
      {
        path: "front/:articleid?",
        name: "frontpage",
        component: FrontPageLayout
      },
      {
        path: "view/:articleid?",
        name: "viewarticle",
        component: ViewArticleLayout
      }
    ]
  }
];
